<script setup lang="ts">
import DropdownListElement from "./DropdownListElement.vue";
import { ref, computed, watch, onMounted, onUnmounted } from "vue";

import { useSiteOperationalDataStore } from "../../store/siteOperationalData.store";
const siteOperationalStore = useSiteOperationalDataStore();

interface OptionSelectionDropdown {
  label: string;
  icon: string;
  isSelected: boolean;
  isOpen: boolean;
}

const props = defineProps({
  initValue: {
    type: Object,
    required: true,
  },
  selectionList: {
    type: Array<OptionSelectionDropdown>,
    required: true,
  },
  dropdownActions: {
    type: Function,
    required: false,
  },
  selectChoice: {
    type: Function,
    required: false,
  },
  isOpen: {
    type: Boolean,
    default: undefined,
  },
  isAside: {
    type: Boolean,
    default: false,
  },
  isAbsolute: {
    type: Boolean,
    default: true,
  },
  isScrool: {
    type: Boolean,
    default: false,
  },
  isStatic: {
    type: Boolean,
    default: false,
  },
  displayValue: {
    type: String,
    required: false,
    default: "label",
  },
  displayValueOther: {
    type: String,
    required: false,
    default: "",
  },
  isComboParam: {
    type: Boolean,
    default: false,
  },
  filtreable: {
    type: Boolean,
    default: false,
  },
  fieldsFilter: {
    type: String,
    default: "",
  },
  inputForm: {
    type: Boolean,
    default: false,
    required: false,
  },
  small: {
    type: Boolean,
    default: false,
    required: false,
  },
  focusable: {
    type: Boolean,
    required: false,
    default: true,
  },
});
const selectedValue = ref(props.initValue);
const searchValue = ref("")
const isDropdownOpen = ref(false);
const isDropdownState = computed(() =>
  props.isOpen !== undefined ? props.isOpen : isForceCloseMenu.value,
);

const emit = defineEmits([
  "openModalProfil",
  "openProfil",
  "logout",
  "forceCloseMenuItem",
]);

const dropdownRef = ref(null);

onMounted(() => {
  document.addEventListener('click', handleOutsideClick);
});

onUnmounted(() => {
  document.removeEventListener('click', handleOutsideClick);
});

const handleOutsideClick = (e) => {
  if (dropdownRef.value && !dropdownRef.value.contains(e.target)) {    
      isForceCloseMenu.value = !isForceCloseMenu.value;
      emit("forceCloseMenuItem");
  }
};

const isForceCloseMenu = ref(props.isOpen);

const forceCloseSubMenu = (selection) => {

  if(selection.submenu) {

    for (let index = 0; index < selection.submenu.length; index++) {
      const element = selection.submenu[index];
      
      if(element.path) {
        emit("forceCloseMenuItem");
        break;
      }      
      
    }
  }

}

const forceCloseMenuItem = (selection) => {

    if(selection.path) {
      isForceCloseMenu.value = !isForceCloseMenu.value;

      emit("forceCloseMenuItem");
    }
  
};

const toggleDropdown = () => {

  if(props.initValue.path) {
    siteOperationalStore.setCurrentPage("");
    window.location.href = props.initValue.path;
  }

  if (props.dropdownActions) {
    props.dropdownActions(selectedValue.value);
    emit("openProfil");
  } else {
    isForceCloseMenu.value = !isForceCloseMenu.value;
  }
};

const optionSelected = (value: any) => {
  isDropdownOpen.value = !isDropdownOpen.value;
  selectedValue.value = value;
  if (props.selectionList) {
    props.selectionList.forEach((selection: any) => {
      if (selection === value) {
        selection.isOpen = !value.isOpen;
      } else {
        selection.isOpen = false;
      }
    });
  }
};

const listSearch = computed(() => {

  if(searchValue.value == '') {
    return props.selectionList
  } else {
    if(props.fieldsFilter != '') {
      return props.selectionList.filter(x => x[props.fieldsFilter].includes(searchValue.value) && searchValue.value != '' )
    } else {
      return props.selectionList.filter(x => x.label.includes(searchValue.value) && searchValue.value != '' )
    }
  }
  
})

watch(
  () => props.initValue,
  (valueSet) => {
    selectedValue.value = valueSet;
  },
);

const tabNumber = computed(() => (props.focusable ? "" : "-1"));



</script>

<template>

  <!-- onclick="if(props.initValue.path == 'Profil') { window.location.href = props.initValue.path; }" -->

  <div class="dropdown" v-bind:class="{ inputform: !props.inputForm }" ref="dropdownRef">
    <button
      class="dropdown-button tooltip-right"
      :tabindex="tabNumber"
      v-bind:class="{
        'dropdown-button--active': isDropdownState,
        'input__field--small': props.small,
      }"
      @click="toggleDropdown()"
      type="button"
      :hover-tooltip="props.initValue.label"
      tooltip-position="top"
      
    >
      <slot buttonContent>
        <div>
          <input
            class="input__field input__field--small" style="border: none;" v-if="props.filtreable && selectedValue == null" v-model="searchValue"
          />
          <img
            v-if="selectedValue?.icon"
            :src="`/images/${selectedValue?.icon}`"
            :alt="initValue?.icon"
            class="dropdown__line-img"
          />
          <span
            class="dropdown-button--text dropdown__line-name"
            v-if="!props.isComboParam"
            >{{ selectedValue?.label }}</span
          >
          <span class="dropdown-button--text dropdown__line-name" v-else>{{
            selectedValue?.[props.displayValue]
          }}</span>
        </div>
        <img
          class="chevron"
          :class="{ 'dropdown-button--chevron': isDropdownState }"
          src="/src/assets/images/chevron.svg"
        />
      </slot>
    </button>
    <div
      v-if="isDropdownState"
      class="dropdown-button__container"
      :class="{
        'dropdown-button__container--aside': isAside,
        'dropdown-button__container--absolute': isAbsolute && !isScrool,
        'dropdown-button__container--absolute--scrool': isAbsolute && isScrool,
      }"
    >
      <p v-if="isAside" class="dropdown-button__container--label">
        {{ initValue.label }}
      </p>
      <ul>
        <template v-for="selection in listSearch" :key="selection.label">
          <DropdownListElement
            :element="selection"
            :selectChoice="selectChoice"
            :isExtended="isAside"
            @selectedChoice="optionSelected"
            @openModalProfil="emit('openModalProfil')"
            @logout="emit('logout')"
            :display-value="props.displayValue"
            :display-value-other="props.displayValueOther"
            @forceCloseMenu="forceCloseMenuItem(selection)"
            @forceCloseSubMenu="forceCloseSubMenu(selection)"
            :isComboParam="props.isComboParam"
          />
          <!-- forceCloseMenuItem-->
        </template>
      </ul>
    </div>
  </div>
</template>

<style lang="scss">
@use "../../assets/css/utils/_variables.scss" as *;

[hover-tooltip] {
  position: relative;
  cursor: default;
  
}
button:not(.dropdown-button--active)[hover-tooltip]:hover::before {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  content: attr(hover-tooltip);
  font-size: 14px;
  text-align: center;
  position: absolute;
  display: block;
  left: 230%;
  min-width: 120px;
  width: max-content;
  transform: translate(-50%);
  background: #2B48A2;
  border-radius:5%;
  //padding: 18.5px;
  padding:10px;
  color: #ffffff;
  z-index: 5;
}
[hover-tooltip]:hover::after {
  content:'';
    position:absolute;
    top: 50%;
    left: 100%;
    margin-top: -6px;
    margin-left: 4px;
    transform:translate(50%,-50%) rotate(-45deg);
    background-color:#2B48A2;
    box-shadow:0 1px 8px rgba(0,0,0,0.5);
}
[hover-tooltip][tooltip-position=bottom]:hover::before {
  bottom: auto;
  top: calc(100% + 10px);
}
[hover-tooltip][tooltip-position=bottom]:hover::after {
  bottom: auto;
  top: calc(100% + 6px);
  border-color: transparent transparent #272727;
  border-width: 0 6px 4px;
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.dropdown {
  position: relative;

  &--grey {
    width: max-content;

    .dropdown-button {
      color: $white;
      background-color: $dark-grey;
      font-weight: $weight-m;
      gap: 2rem;

      img {
        filter: brightness(0) invert(1);
      }
    }
  }

  .inputform {
    width: 244px;
  }

  &--blue {
    width: max-content;

    .dropdown-button {
      background-color: $blue;
      color: $white;
      font-weight: $weight-m;
      gap: 1rem;

      &:hover {
        background-color: $dark-grey !important;
      }

      &__container {
        width: max-content;
        left: 0;
      }
    }
  }

  &--client {
    z-index: 5;

    .dropdown-button {
      &--active {
        background-color: $white;

        .menu__dropdown--name {
          color: $dark-grey;
        }
      }
    }
  }

  &--fixed {
    .dropdown-button__container {
      position: fixed;
    }
  }

  &-button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    padding: 16px 14px;
    border-radius: 4px;
    border: 1px solid lightgrey;
    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.08);
    background-color: inherit;
    font-size: 14px;
    width: 100%;
    cursor: pointer;

    &--chevron {
      transform: rotate(180deg);
    }

    &:hover {
      .chevron,
      .dropdown__line-img {
        filter: brightness(0) invert(1);
      }

      &:not(.dropdown-button--active) {
        background-color: $blue;
        color: $white;
      }
    }

    &--active {
      background-color: $dark-grey;
      color: $white;

      .menu__client {
        & .menu__dropdown--chevron {
          filter: unset;
        }
      }

      .menu__dropdown--chevron {
        transform: rotate(180deg);
      }
    }

    &--text {
      margin-left: 18px;
      margin-right: 24px;
    }

    &__container {
      box-sizing: border-box;
      z-index: 2;
      border-radius: 4px;
      width: 100%;
      color: $white;

      @include scrollbarBlack;

      &--label {
        padding: 0 16px;
      }

      &--absolute {
        position: absolute;
        margin-top: 0.4rem;
        background-color: $white;
        color: $black-grey;
        padding: 8px 4px;
        border: 1px solid #e4e5ea;
        z-index: 3;

        &--scrool {
          position: absolute;
          margin-top: 0.4rem;
          background-color: $white;
          color: $black-grey;
          padding: 8px 4px;
          border: 1px solid #e4e5ea;
          height: 10rem;
          overflow-y: auto;
        }

        &-right {
          left: unset;
          right: 0;
        }

        .dropdown-button__container--list {
          //padding: 8px 16px;
          p {
            margin: 0;
          }
        }
      }

      &--aside {
        left: 100%;
        top: 0;
        margin: 0 0 0 4px;
        min-width: max-content;
        width: 228px;
        text-align: left;

        .dropdown-button__container--label {
          font-size: 14px;
          font-weight: 700;
        }
        .dropdown-button__container--list {
          text-align: left;
          div {
            padding: 0;
          }
          p {
            line-height: 20px;
            margin: 0;
          }
        }

        .submenu__container {
          border: 1px solid $grey;
          border-radius: 4px;
          margin-left: 10px;
        }
      }

      ul {
        margin: 4px;
        padding: 0;
      }
    }
  }
  .submenu--chevron {
    filter: brightness(0) invert(1);
    transform: rotate(-90deg);
  }

  &__container--padding {
    padding: 0 0 0 39px;
  }
}

.dropdown-button__container--absolute {
    background-color: #333645 !important;
    color:white;
}

.el-popper.is-customized {
  /* Set padding to ensure the height is 32px */
  padding: 6px 12px;
  background: #1700db;
  color:white;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 15px;
}

.el-popper.is-customized .el-popper__arrow::before {
  background: #1700db;
  right: 0;
}

</style>
